import { useState } from "react";
import { Box, Skeleton } from "@mantine/core";
import type { CSSProperties } from "react";

interface LazyImageProps {
  src: string;
  alt: string;
  color?: string | null;
  style?: CSSProperties;
}

// Native lazy loading: the browser defers the request until the image is near the
// viewport and serves repeat views from its HTTP cache (the blob endpoint sends
// `Cache-Control: immutable`). A Skeleton covers the coloured box until the image
// loads; the box keeps its aspect ratio either way, so loading never shifts scroll.
export default function LazyImage({ src, alt, color, style }: LazyImageProps) {
  const [loaded, setLoaded] = useState(false);

  return (
    <Box
      style={{
        position: "relative",
        background: color ?? undefined,
        aspectRatio: "1",
        overflow: "hidden",
        ...style,
      }}
    >
      <img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        onLoad={() => setLoaded(true)}
        style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
      />
      {!loaded && <Skeleton height="100%" radius={0} style={{ position: "absolute", inset: 0 }} />}
    </Box>
  );
}
